import React from 'react';
import { RichTextEditor, ChakraUIProvider } from '@everfi/reactifi';
import { s3NextUploader } from '../utility/s3NextUploader';
import PropTypes from 'prop-types';
import Summernote from 'lib/components/Summernote';
import SummernoteHelper from 'lib/utility/summernote_helper';
import { CodeEditor } from './CodeEditor';
import { MediaUrlPicker } from './MediaUrlPicker';

export const RichNextEditor = ({
  showImageUrlButton,
  summernoteProps,
  initialValue,
  shouldSanitize,
  formElementName,
  allowCodeToggle,
  onChange,
  editor = 'summernote',
}) => {


  const editors = {
    summernote: () => {
      const helper = new SummernoteHelper();
      return (
        <div className="summernote">
          <Summernote
            defaultValue={initialValue}
            onChange={onChange}
            options={
              summernoteProps?.editorOptions || helper.defaultEditorOptions
            }
            {...summernoteProps}
            shouldSanitize={shouldSanitize}
          />
        </div>
      );
    },
    slate: () => {
      return (
        <ChakraUIProvider>
          <RichTextEditor
            initialValue={initialValue}
            dataType="html"
            onChange={onChange}
            shouldSanitize={shouldSanitize}
            allowCodeToggle={allowCodeToggle}
            formElementName={formElementName}
            uploader={s3NextUploader}
          />
        </ChakraUIProvider>
      );
    },
    codemirror: () => {
      return (
        <ChakraUIProvider>
          <CodeEditor
            initialValue={initialValue}
            onChange={onChange}
            shouldSanitize={shouldSanitize}
            formElementName={formElementName}
          />
        </ChakraUIProvider>
      );
    },
  };
  const paramOverride = new URLSearchParams(window.location.search).get(
    'editor'
  );

  return (
    <>
      {showImageUrlButton && (
        <ChakraUIProvider>
          <MediaUrlPicker accountId={summernoteProps.accountId} />
        </ChakraUIProvider>
      )}
      {editors[paramOverride ? paramOverride : editor]()}
    </>
  );
};

RichNextEditor.propTypes = {
  showImageUrlButton: PropTypes.bool,
  summernoteProps: PropTypes.object,
  initialValue: PropTypes.string,
  shouldSanitize: PropTypes.bool,
  formElementName: PropTypes.string,
  allowCodeToggle: PropTypes.bool,
  onChange: PropTypes.func,
  editor: PropTypes.string,
  accountId: PropTypes.string,
};
